import React, { createContext, useContext, useEffect, useState } from "react";

type User = {
  id: string;
  email: string;
  role: "user" | "admin";
  is_active: boolean;
};

type AuthContextType = {
  user: User | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: true,
  setUser: () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) setUser(JSON.parse(stored));
    setIsLoading(false);
  }, []);

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem("selected_client");
    localStorage.removeItem("draft_preview");
    localStorage.removeItem("preview_result");
    localStorage.removeItem("issued_invoice_ids");
    localStorage.removeItem("builder_payload");
    localStorage.removeItem("builder_anchor_start");
    localStorage.removeItem("builder_date_policy");
  };

  return (
    <AuthContext.Provider value={{ user, setUser, isLoading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);